<template>
  <div
    class="group absolute z-[1501] cursor-pointer"
    :class="{
      'top-[56px]': topBarStore.showMainTopBar,
      'top-[88px]':
        topBarStore.showMainTopBar &&
        topBarStore.showWindowBar &&
        layoutStore.hideControlPanel,
      'top-0': !topBarStore.showMainTopBar,
      'top-[32px]':
        !topBarStore.showMainTopBar &&
        topBarStore.showWindowBar &&
        layoutStore.hideControlPanel,
      'left-full': !alignRight && !layoutStore.hideControlPanel,
      'right-full': alignRight && !layoutStore.hideControlPanel,
      'left-0': !alignRight && layoutStore.hideControlPanel,
      'right-0': alignRight && layoutStore.hideControlPanel,
    }"
    @click="layoutStore.toggleControlPanel()"
  >
    <svg
      width="28"
      height="32"
      viewBox="0 0 28 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      :style="{
        transform: alignRight ? 'scaleX(-1)' : 'none',
      }"
    >
      <path
        d="M0 0H28V23.3101C28 26.3467 25.7314 28.9045 22.7166 29.2672L0 32V0Z"
        class="fill-gray-700 transition-all duration-300 group-hover:fill-gray-500"
      ></path>
      <path
        v-if="!layoutStore.hideControlPanel"
        d="M9.1875 18.3438C9.1875 18.7266 8.88672 19 8.53125 19C8.14844 19 7.875 18.7266 7.875 18.3438V9.15625C7.875 8.80078 8.14844 8.5 8.53125 8.5C8.88672 8.5 9.1875 8.80078 9.1875 9.15625V18.3438ZM15.3125 16.7852C15.5859 17.0312 15.5859 17.4414 15.3398 17.7422C15.0938 17.9883 14.6836 18.0156 14.4102 17.7695L10.6914 14.2695C10.418 14.0234 10.418 13.5586 10.6914 13.3125L14.4102 9.8125C14.6836 9.56641 15.0938 9.56641 15.3398 9.83984C15.4492 9.97656 15.5039 10.1133 15.5039 10.2773C15.5039 10.4688 15.4492 10.6328 15.3125 10.7695L12.7969 13.1211H19.4414C19.8242 13.1211 20.125 13.3945 20.125 13.75C20.125 14.1328 19.8242 14.4062 19.4414 14.4062H12.7969L15.3125 16.7852Z"
        class="fill-gray-100 transition duration-300 group-hover:fill-gray-50"
      ></path>
      <path
        v-else
        d="M9.1875 18.3438C9.1875 18.7266 8.88672 19 8.53125 19C8.14844 19 7.875 18.7266 7.875 18.3438V9.15625C7.875 8.80078 8.14844 8.5 8.53125 8.5C8.88672 8.5 9.1875 8.80078 9.1875 9.15625V18.3438ZM15.2852 10.7422C15.0391 10.4961 15.0117 10.0859 15.2578 9.8125C15.5039 9.53906 15.9414 9.53906 16.1875 9.78516L19.9062 13.2852C20.1797 13.5312 20.1797 13.9961 19.9062 14.2422L16.1875 17.7422C15.9414 17.9883 15.5039 17.9883 15.2578 17.7148C15.1484 17.5781 15.0938 17.4141 15.0938 17.25C15.0938 17.0859 15.1484 16.9219 15.2852 16.7852L17.8008 14.4062H11.1562C10.7734 14.4062 10.5 14.1328 10.5 13.75C10.5 13.3945 10.7734 13.0938 11.1562 13.0938H17.8008L15.2852 10.7422Z"
        class="fill-gray-100 transition duration-300 group-hover:fill-gray-50"
      ></path>
    </svg>
  </div>
</template>

<script lang="ts" setup>
  import { useLayoutStore } from "@/stores/layoutStore";
  import { useTopBarStore } from "@/stores/topBar";
  import { computed } from "vue";

  const layoutStore = useLayoutStore();
  const topBarStore = useTopBarStore();

  const alignRight = computed(() => {
    return layoutStore.mainMenuAlign === "right";
  });
</script>
